































































import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { APP_CONFIG } from '@/config/app-config';
import { Auth } from '@/models/auth';
import authService from '@/services/auth-services';
import localStorage from '@/utility/localStorage';
import commonServices from '@/services/common-services';
import notificationSound from '@/utility/notification-sound';
import { eventBus } from '@/main';
import Notification from './Notification.vue';

@Component({
    components: {
        'notification': Notification
    }
})
export default class AppHeader extends Vue {
    private isOpenMenuUser = false;
    private totalNotify = 0;
    private activeToast: any = null;
    private toastTimer: any = null;

    get showMenuLeft() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get isToken() {
        return authProvider.isToken();
    }

    private onOpenUserMenu() {
        this.isOpenMenuUser = !this.isOpenMenuUser;
    }

    private async onLogout() {
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }

    private onToggleMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', !this.showMenuLeft);
    }

    private getTotalNotification(total: any) {
        this.totalNotify = total.public_total + total.global_total;
    }

    private handleNewMessage(notif: any) {
        if (!notif) return;

        let title = 'Tin nhắn mới từ nhân viên';
        if (notif.OrderType == 100 || notif.OrderType == 7 || notif.OrderType == 8) {
            title = 'Bình luận mới trong báo giá #' + (notif.OrderID || '');
        } else if (notif.OrderID) {
            title = 'Tin nhắn mới đơn hàng #' + notif.OrderID;
        }

        this.activeToast = {
            id: notif.ID,
            orderId: notif.OrderID,
            orderType: notif.OrderType,
            title: title,
            message: notif.Message || 'Bạn có một tin nhắn mới.',
            time: 'Vừa xong',
            notif: notif
        };

        // Phát chuông âm thanh
        try {
            notificationSound.playChime();
        } catch (e) {}

        // Hiển thị Browser Web Notification nếu được cấp quyền
        try {
            if (notificationSound.hasBrowserPermission) {
                const cleanText = (notif.Message || '').replace(/<[^>]+>/g, '');
                notificationSound.showBrowserNotification(title, {
                    body: cleanText,
                }, () => {
                    const isQuotation = notif.OrderType == 100 || notif.OrderType == 7 || notif.OrderType == 8 || (notif.Message && notif.Message.toLowerCase().includes('báo giá'));
                    if (isQuotation) {
                        const routeData = this.$router.resolve({
                            name: 'quotation-detail',
                            params: { id: notif.OrderID.toString() },
                            query: { tab: 'chat' }
                        });
                        window.open(routeData.href, '_blank');
                    } else if (notif.OrderType == APP_CONFIG.ORDER_TYPE.deposit) {
                        this.$router.push({ name: 'deposit-detail', params: { id: notif.OrderID.toString() } }).catch(() => {});
                    } else {
                        this.$router.push({ name: 'order-detail', params: { orderId: notif.OrderID.toString() } }).catch(() => {});
                    }
                });
            }
        } catch (e) {}

        // Tự động đóng popup sau 8 giây
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
        this.toastTimer = setTimeout(() => {
            this.activeToast = null;
        }, 8000);
    }

    private closeToast() {
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
        this.activeToast = null;
    }

    private onToastClick() {
        if (!this.activeToast) return;
        const notif = this.activeToast.notif;
        this.closeToast();

        if (notif && notif.ID) {
            commonServices.updateStatusNotification(notif.ID, { Status: 1 }).then(() => {
                eventBus.$emit(APP_CONFIG.eventBusAction.reloadNotification, null);
            }).catch(() => {});
        }

        if (!notif || !notif.OrderID) return;

        const isQuotation = notif.OrderType == 100 || notif.OrderType == 7 || notif.OrderType == 8 || (notif.Message && notif.Message.toLowerCase().includes('báo giá'));
        if (isQuotation) {
            const routeData = this.$router.resolve({
                name: 'quotation-detail',
                params: { id: notif.OrderID.toString() },
                query: { tab: 'chat' }
            });
            window.open(routeData.href, '_blank');
        } else if (notif.OrderType == APP_CONFIG.ORDER_TYPE.deposit) {
            this.$router.push({ name: 'deposit-detail', params: { id: notif.OrderID.toString() } }).catch(() => {});
        } else {
            this.$router.push({ name: 'order-detail', params: { orderId: notif.OrderID.toString() } }).catch(() => {});
        }
    }
}
